export default __webpack_public_path__ + "static/flyer2-b11553cd7e4c62e227e1a3fb85cdecfc.jpg";